import { type ComponentPropsWithoutRef, memo } from 'react';
import { tv, type VariantProps } from 'tailwind-variants';

import { cn } from '../../lib/cn';

export const badgeVariants = tv({
  base: 'focus:ring-ring inline-flex items-center gap-1 rounded-md border text-xs font-medium transition-colors focus:outline-none focus:ring-2 focus:ring-offset-2',
  variants: {
    variant: {
      primary:
        'bg-chat-primary text-chat-primary-foreground border-transparent',
      secondary:
        'bg-chat-secondary text-chat-secondary-foreground border-transparent',
      destructive:
        'bg-chat-destructive text-chat-destructive-foreground border-transparent',
      outline: 'border-chat-input-border bg-chat-background border',
    },
    size: {
      xs: 'px-1 py-0 text-[10px]',
      sm: 'px-1.5 py-0 text-xs',
      md: 'px-2 py-0.5 text-xs',
      lg: 'px-2 py-0.5 text-sm',
      xl: 'px-3 py-1 text-base',
    },
    disabled: {
      true: 'cursor-not-allowed opacity-50',
    },
  },
  defaultVariants: {
    variant: 'primary',
    size: 'md',
  },
});

export interface BadgeProps
  extends ComponentPropsWithoutRef<'span'>,
    VariantProps<typeof badgeVariants> {
  circle?: boolean;
}

export const Badge = memo(
  ({
    className,
    variant,
    size,
    disabled,
    circle = false,
    ...restProps
  }: BadgeProps) => (
    <span
      className={cn(
        badgeVariants({
          variant,
          size,
          disabled,
        }),
        circle && 'rounded-full',
        className,
      )}
      data-uui-badge
      {...restProps}
    />
  ),
);
